/* eslint-disable import/prefer-default-export */
export const DEFAULT_RSC_INFO_LIST = [
  'SMS._.CPU.TOTAL_USERATE',
  'SMS._.MEM_PHY.USERATE',
  'SMS._.MEM_SWP.USERATE',
  'SMS._.DISK.DISK_USERATE',
  'NMS.ND.DEVICE_PERF.CPU_USERATE',
  'NMS.ND.DEVICE_PERF.MEM_USERATE',
  'NMS.ND.DEVICE_PERF.DEVICE_TEMP',
  'NMS.ND.RESPONSETIME.RESPONSETIME_ICMP',
  'NMS.NI.TRAFFIC.TRAFFIC_BPS_IN',
  'NMS.NI.TRAFFIC.TRAFFIC_BPS_OUT',
  'NMS.NI.TRAFFIC_ERROR.TRAFFIC_ERROR_IN',
  'NMS.NI.TRAFFIC_ERROR.TRAFFIC_ERROR_OUT',
  'DBMS._.MEMSTAT.DB_BUF_CACHE_HITRATIO',
  'DBMS._.TABLESPACE.DB_TABLESPACE_USERATE',
  'DBMS._.LOCK.DB_LOCK_COUNT',
  'DBMS._.SESS.DB_SESS_COUNT',
  'E2E._.SERVICESTATUS.RESPONSETIME_TOTAL',
  'FMS.FS.FTHEHYGRO.CUR_TEMPERATURE',
  'FMS.FS.FTHEHYGRO.CUR_HUMIDITY',
  'FMS.FS.FUPS.INPUT_VOLTAGE',
  'FMS.FS.FUPS.OUTPUT_VOLTAGE',
  'FMS.FS.FUPS.INPUT_CURRENT',
  'FMS.FS.FUPS.OUTPUT_CURRENT',
  'FMS.FS.FTH.TEMPERATURE',
  'FMS.FS.FTH.HUMIDITY',
  'FMS.FS.FRT.DC_CURRENT',
  'FMS.FS.FRT.LOAD_CURRENT',
  'FMS.FS.FRT.INPUT_CURRENT',
  'FMS.FS.FRT.BATTERY_CURRENT',
  'FMS.FS.FGCU.PHASE_VOLTAGE_S  ',
  'FMS.FS.FGCU.LINE_VOLTAGE_R',
  'FMS.FS.FGCU.PHASE_CURRENT_R',
  'FMS.FS.FGCU.ACTIVE_PWR',
  'VMS.VCL.VCL_CPU.USERATE',
  'VMS.VCL.VCL_MEM.USERATE',
  'VMS.VCL.VCL_CPU.USERATE',
  'VMS.VHO.VHO_CPU.USERATE',
  'VMS.VHO.VHO_MEM.USERATE',
  'VMS.VVM.VVM_CPU.USERATE',
  'VMS.VVM.VVM_MEM.USERATE',
  'VMS.VVM.VVM_DISK.USERATE',
  'VMS.VDSC.VDSC_STORAGE.USERATE',
  'VMS.VDSC.VDSC_STORAGE.AVSIZE',
  'VMS.VDS.VDS_STORAGE.USERATE',
  'VMS.VDS.VDS_STORAGE.AVSIZE',
];



// WEBPACK FOOTER //
// ./src/constants/report.js